import { render, staticRenderFns } from "./RepeatRecipientList.vue?vue&type=template&id=116f2a6e&"
import script from "./RepeatRecipientList.vue?vue&type=script&lang=js&"
export * from "./RepeatRecipientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports